import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import LoadingModal from './LoadingModal';
import useDefaultModal from '../hooks/useDefaultModal';
import DefaultModal from './DefaultModal';

function DemandaModal({ show, onClose, onSuccess, demanda, usuarios = [], readOnly = false }) {
  const vinculo = JSON.parse(localStorage.getItem('vinculo') || '{}');
  const entidade = vinculo?.entidade || {};
  const entidadeId = entidade.idEntidade || vinculo?.idEntidade;

  const [formData, setFormData] = useState({
    titulo: '',
    descricao: '',
    entidadeCnpj: '',
    anoBase: new Date().getFullYear(),
    tipoServico: 'INTERNO',
    tipoAtendimento: 'PRESENCIAL',
    orgaoId: '',
    departamentoId: '',
    responsavelCpf: '',
    prioridade: 'MEDIA',
    status: 'ABERTA',
    dataPrazo: '',
  });
  const [orgaos, setOrgaos] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [funcionarios, setFuncionarios] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const usuario = JSON.parse(localStorage.getItem('user') || '{}');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  const getNomeUsuario = cpf => {
    const u = usuarios.find(usr => usr.cpf === cpf);
    return u ? u.nome : cpf;
  };

  useEffect(() => {
    if (show) {
      const anoBase = localStorage.getItem('anoBase') || new Date().getFullYear();
      if (demanda) {
        setFormData({
          titulo: demanda.titulo || '',
          descricao: demanda.descricao || '',
          entidadeCnpj: demanda.entidadeCnpj || entidade?.cnpj || '',
          anoBase: demanda.anoBase || Number(anoBase),
          tipoServico: demanda.tipoServico || 'INTERNO',
          tipoAtendimento: demanda.tipoAtendimento || 'PRESENCIAL',
          orgaoId: demanda.orgaoId || '',
          departamentoId: demanda.departamentoId || '',
          responsavelCpf: demanda.responsavelCpf || usuario.cpf || '',
          prioridade: demanda.prioridade || 'MEDIA',
          status: demanda.status || 'ABERTA',
          dataPrazo: demanda.dataPrazo || '',
        });
      } else {
        setFormData({
          titulo: '',
          descricao: '',
          entidadeCnpj: entidade?.cnpj || '',
          anoBase: Number(anoBase),
          tipoServico: 'INTERNO',
          tipoAtendimento: 'PRESENCIAL',
          orgaoId: '',
          departamentoId: '',
          responsavelCpf: usuario.cpf || '',
          prioridade: 'MEDIA',
          status: 'ABERTA',
          dataPrazo: '',
        });
      }
    }
  }, [demanda, show]);

  useEffect(() => {
    if (show && entidadeId) {
      axios
        .get(`${API_BASE_URL.ORGAO}/entidade/${entidadeId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => setOrgaos(res.data))
        .catch(() => setOrgaos([]));
    } else {
      setOrgaos([]);
    }
    setDepartamentos([]);
  }, [show, entidadeId, token]);

  useEffect(() => {
    if (show && entidadeId) {
      axios
        .get(`${API_BASE_URL.VINCULO}/entidade/${entidadeId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => setColaboradores(res.data))
        .catch(() => setColaboradores([]));
    } else {
      setColaboradores([]);
    }
  }, [show, entidadeId, token]);

  useEffect(() => {
    if (show && formData.orgaoId) {
      axios
        .get(`${API_BASE_URL.ORGAO_DEPARTAMENTO}/orgao/${formData.orgaoId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => setDepartamentos(res.data))
        .catch(() => setDepartamentos([]));
    } else {
      setDepartamentos([]);
    }
  }, [show, formData.orgaoId, token]);

  useEffect(() => {
    if (show && formData.orgaoId) {
      axios
        .get(`${API_BASE_URL.ORGAO_FUNCIONARIO}/orgao/${formData.orgaoId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => {
          let funcs = res.data;
          if (formData.departamentoId) {
            funcs = funcs.filter(f => f.idDepartamento === Number(formData.departamentoId));
          }
          setFuncionarios(funcs);
        })
        .catch(() => setFuncionarios([]));
    } else {
      setFuncionarios([]);
    }
  }, [show, formData.orgaoId, formData.departamentoId, token]);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'orgaoId') {
      setFormData(prev => ({ ...prev, orgaoId: value, departamentoId: '', responsavelCpf: '' }));
    } else if (name === 'departamentoId') {
      setFormData(prev => ({ ...prev, departamentoId: value, responsavelCpf: '' }));
    } else if (name === 'tipoServico') {
      if (value === 'INTERNO') {
        setFormData(prev => ({ ...prev, tipoServico: value, orgaoId: '', departamentoId: '', responsavelCpf: '' }));
      } else {
        setFormData(prev => ({ ...prev, tipoServico: value, responsavelCpf: '' }));
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (formData.dataPrazo) {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      const prazo = new Date(formData.dataPrazo + 'T00:00:00');
      if (prazo < hoje) {
        showDefaultModal('error', 'O prazo não pode ser anterior à data de criação!');
        return;
      }
    }

    setLoading(true);

    const payload = {
      ...formData,
      anoBase: Number(formData.anoBase) || new Date().getFullYear(),
      orgaoId: formData.orgaoId ? Number(formData.orgaoId) : null,
      departamentoId: formData.departamentoId ? Number(formData.departamentoId) : null,
      responsavelCpf: formData.responsavelCpf || usuario.cpf,
      criadoPorCpf: usuario.cpf,
    };

    if (demanda) {
      payload.id = demanda.id;
      payload.dataCriacao = demanda.dataCriacao;
      if (demanda.criadoPorCpf) payload.criadoPorCpf = demanda.criadoPorCpf;
    }

    const request = demanda
      ? axios.put(`${API_BASE_URL.DEMANDA}/update`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      : axios.post(`${API_BASE_URL.DEMANDA}/save`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

    request
      .then(() => {
        onSuccess();
      })
      .catch(error => {
        console.error('Erro ao salvar demanda:', error);
        showDefaultModal('error', 'Erro ao salvar demanda!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-lg" style={{ maxHeight: '90vh', display: 'flex', margin: '1.75rem auto' }}>
          <div className="modal-content" style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
            <div
              className="modal-header text-white py-1"
              style={{
                background:
                  'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
                border: 'none',
                flexShrink: 0,
              }}
            >
              <h6 className="modal-title">
                <i className="bi bi-clipboard-check me-2"></i>
                {readOnly ? 'Visualizar Demanda' : demanda ? 'Editar Demanda' : 'Nova Demanda'}
              </h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
            </div>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <div className="modal-body" style={{ overflowY: 'auto' }}>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label fw-semibold" style={{ fontSize: '0.8rem' }}>
                      Título *
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="titulo"
                      value={formData.titulo}
                      onChange={handleChange}
                      disabled={readOnly}
                      required
                      maxLength={200}
                      placeholder="Ex: Consultoria para elaboração de projeto"
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label fw-semibold" style={{ fontSize: '0.8rem' }}>
                      Descrição
                    </label>
                    <textarea
                      className="form-control form-control-sm"
                      name="descricao"
                      value={formData.descricao}
                      onChange={handleChange}
                      disabled={readOnly}
                      rows={3}
                      placeholder="Descreva a demanda detalhadamente..."
                    />
                  </div>
                  <div className="col-12">
                    <div className="d-flex gap-5 flex-wrap">
                      <div>
                        <label className="form-label fw-semibold" style={{ fontSize: '0.8rem' }}>
                          Tipo de Serviço
                        </label>
                        <div className="d-flex gap-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="tipoServico"
                              id="tipoInterno"
                              value="INTERNO"
                              checked={formData.tipoServico === 'INTERNO'}
                              onChange={handleChange}
                              disabled={readOnly}
                            />
                            <label className="form-check-label fw-semibold" htmlFor="tipoInterno" style={{ fontSize: '0.8rem' }}>
                              Interno (Entidade)
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="tipoServico"
                              id="tipoExterno"
                              value="EXTERNO"
                              checked={formData.tipoServico === 'EXTERNO'}
                              onChange={handleChange}
                              disabled={readOnly}
                            />
                            <label className="form-check-label fw-semibold" htmlFor="tipoExterno" style={{ fontSize: '0.8rem' }}>
                              Externo (Órgão)
                            </label>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label className="form-label fw-semibold" style={{ fontSize: '0.8rem' }}>
                          Tipo de Atendimento
                        </label>
                        <div className="d-flex gap-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="tipoAtendimento"
                              id="atendimentoPresencial"
                              value="PRESENCIAL"
                              checked={formData.tipoAtendimento === 'PRESENCIAL'}
                              onChange={handleChange}
                              disabled={readOnly}
                            />
                            <label className="form-check-label fw-semibold" htmlFor="atendimentoPresencial" style={{ fontSize: '0.8rem' }}>
                              Presencial
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="tipoAtendimento"
                              id="atendimentoVirtual"
                              value="VIRTUAL"
                              checked={formData.tipoAtendimento === 'VIRTUAL'}
                              onChange={handleChange}
                              disabled={readOnly}
                            />
                            <label className="form-check-label fw-semibold" htmlFor="atendimentoVirtual" style={{ fontSize: '0.8rem' }}>
                              Virtual
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {formData.tipoServico === 'EXTERNO' && (
                    <>
                    <div className="col-md-6">
                      <label className="form-label fw-semibold" style={{ fontSize: '0.8rem' }}>
                        Órgão Destinatário
                      </label>
                      <select
                        className="form-select form-select-sm"
                        name="orgaoId"
                        value={formData.orgaoId}
                        onChange={handleChange}
                        disabled={readOnly}
                        required
                      >
                        <option value="">Selecione...</option>
                        {orgaos.map(o => (
                          <option key={o.idOrgao} value={o.idOrgao}>
                            {o.nome}
                          </option>
                        ))}
                      </select>
                    </div>
                    {formData.orgaoId && departamentos.length > 0 && (
                      <div className="col-md-6">
                        <label className="form-label fw-semibold" style={{ fontSize: '0.8rem' }}>
                          Departamento/Setor
                        </label>
                        <select
                          className="form-select form-select-sm"
                          name="departamentoId"
                          value={formData.departamentoId}
                          onChange={handleChange}
                          disabled={readOnly}
                        >
                          <option value="">Selecione...</option>
                          {departamentos.map(d => (
                            <option key={d.idDepartamento} value={d.idDepartamento}>
                              {d.nome}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    </>
                  )}
                  <div className={formData.tipoServico === 'INTERNO' ? 'col-md-12' : 'col-md-6'}>
                    <label className="form-label fw-semibold" style={{ fontSize: '0.8rem' }}>
                      {formData.tipoServico === 'INTERNO' ? 'Colaborador Destinatário' : 'Funcionário Destinatário'}
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="responsavelCpf"
                      value={formData.responsavelCpf}
                      onChange={handleChange}
                      disabled={readOnly}
                      required
                    >
                      <option value="">Selecione...</option>
                      {formData.tipoServico === 'INTERNO' && colaboradores.length > 0 && (
                        <optgroup label="Colaboradores da Entidade">
                          {colaboradores.map(v => (
                            <option key={`vinc-${v.cpf}`} value={v.cpf}>
                              {getNomeUsuario(v.cpf)}
                            </option>
                          ))}
                        </optgroup>
                      )}
                      {formData.tipoServico === 'EXTERNO' && funcionarios.length > 0 && (
                        <optgroup label="Funcionários do Órgão">
                          {funcionarios.map(f => (
                            <option key={`func-${f.cpf}`} value={f.cpf}>
                              {f.nome}
                            </option>
                          ))}
                        </optgroup>
                      )}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold" style={{ fontSize: '0.8rem' }}>
                      Prioridade
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="prioridade"
                      value={formData.prioridade}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="BAIXA">Baixa</option>
                      <option value="MEDIA">Média</option>
                      <option value="ALTA">Alta</option>
                      <option value="URGENTE">Urgente</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold" style={{ fontSize: '0.8rem' }}>
                      Status
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                      disabled={readOnly}
                    >
                      <option value="ABERTA">Aberta</option>
                      <option value="EM_ANDAMENTO">Em Andamento</option>
                      <option value="CONCLUIDA">Concluída</option>
                      <option value="CANCELADA">Cancelada</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold" style={{ fontSize: '0.8rem' }}>
                      Prazo
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      name="dataPrazo"
                      value={formData.dataPrazo}
                      onChange={handleChange}
                      disabled={readOnly}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer py-2">
                <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                  {readOnly ? 'Fechar' : 'Cancelar'}
                </button>
                {!readOnly && (
                  <button type="submit" className="btn btn-success btn-sm">
                    <i className="bi bi-check-circle me-1"></i>
                    {demanda ? 'Atualizar' : 'Salvar'}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      {isLoading && <LoadingModal />}
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default DemandaModal;
